<template>
  <div class="footer">
    <div class="footer-logo">
      <img :src="getFooterLogo" alt="MyGames" width="132" height="32" loading="lazy" />
    </div>
    <div class="footer-legal">{{ getFooterLegal }}</div>
    <div class="footer-age">
      <img :src="getFooterAge" alt="18+" width="44" height="44" loading="lazy" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  computed: {
    getFooterLogo() {
      return require("../images/footer-logo.svg");
    },
    getFooterAge() {
      return require("../images/footer-age.svg");
    },
    getFooterLegal() {
      return this.$t("footer.legal", {
        year: new Date().getFullYear(),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/footer";
</style>
